import { AudioTranscriptions as SharedAudioTranscriptions } from "@circle-react-shared/uikit/TranscriptsPlayer/AudioTranscriptions";

export const AudioTranscriptions = SharedAudioTranscriptions;
